<template>
  <div id="app">
    <el-container>
      <el-header :style="headerStyle" class="header-wrapper">
        <div class="header-content">
          <el-image
              @click="goHome"
              class="company-name"
              src="https://niuhui-888.oss-cn-guangzhou.aliyuncs.com/images/genhuilogo.png"></el-image>
          <el-menu
              :text-color="menuTextColor"
              :style="menuTextStyle"
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
          >

            <el-menu-item index="1" @click="$router.push({path: '/'})">Home</el-menu-item>

            <el-menu-item  style="padding: 0px 15px" index="1" v-for="(item,index) in categoryIndexList"
                          :key="index"
                          @click="JumpGoods(item.id)">{{item.categoryName }}</el-menu-item>

            <el-menu-item index="1" @click="$router.push({path: '/company/companyIntroduce'})">Know us</el-menu-item>

            <el-menu-item index="1" @click="$router.push({path: '/company/contactus'})">Contact us</el-menu-item>

          </el-menu>


<!--          关于公司 -->
<!--          <div class="language-selector">-->

<!--            <language-switcher/> &lt;!&ndash; 使用语言切换组件 &ndash;&gt;-->
<!--          </div>-->
        </div>
      </el-header>

      <!-- 走马灯 -->
      <el-main class="main-content" :style="isIndexPage ? 'margin: 0' : ''">
        <router-view/>
      </el-main>

      <el-footer class="footer">
        <div class="footer-container">
          <center style="position: relative;font-size: 12px"><p> Guangzhou Genhey Leather Co., Ltd. 粤ICP备XXXXXXXX号</p></center>
        </div>
        <div style="width: 100%;height: 40px;">
          <p style="position: relative;top: 10px;font-size: 14px">版权所有 © 广州艮辉皮具有限公司</p>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import LanguageSwitcher from '@/components/LangSelect/langSelect.vue'

export default {
  name: 'App',
  components: {LanguageSwitcher},

  data() {
    return {
      activeIndex: '1',
      scrollY: 0,
      scrollY2: 0,
      language: 'zh-CN' ,// 默认语言
      categoryIndexList:[],
      category:null,
    };
  },
  mounted() {
    this.handleScroll(); // 页面加载时立即触发，确保字体颜色正确
    window.addEventListener('scroll', this.handleScroll);
    this.getCategoryIndexList();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    category(){
      location.reload()
    },
  },
  computed: {
    menuTextColor() {
      // 根据header背景颜色动态设置menu字体颜色
      return this.scrollY > 100 ? 'gary' : 'black';
    },
    menuTextStyle() {
      // 如果字体颜色是黑色，添加 text-shadow 样式
      return {}
    },
    isIndexPage() {
      return this.$route.path === '/'; // 检查当前路径是否为首页
    }
    ,
    headerStyle() {
      // 初始背景透明度为 0.5
      const opacity = this.scrollY > 0 ? Math.min(this.scrollY / 100, 1) : 0.5;

      return {
        position: 'fixed',
        width: '100%',
        top: '0',
        left: '0',
        padding: '0',
        transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
        // backgroundColor: this.scrollY > 0 ? `rgba(250, 232, 206, ${opacity})` : 'rgba(255, 255, 255)', // 初始透明白，滚动后变浅米色
        backgroundColor: 'rgba(255, 255, 255)', // 初始透明白，滚动后变浅米色
        boxShadow: opacity > 0 ? '0 2px 10px rgba(0, 0, 0, 0.5)' : 'none',
        zIndex: 1000,
      };
    }

  },

  methods: {
    openBoss() {
      window.open("https://www.zhipin.com/gongsi/e08de94ba80bcf7c1HNy29q1FVM~.html?ka=job-detail-company-logo_custompage", '_blank');
    },
    changeLanguage(value) {
      // 这里可以添加处理语言变化的逻辑，比如调用国际化方法
      console.log("选择的语言:", value)
      alert(value);
      // 你可以根据选择的语言进行相应的国际化处理
    },
    handleScroll() {
      this.scrollY = window.scrollY;
    }
    ,
    goHome() {
      this.$router.push({path: "/"});
    },
    JumpGoods(id) {
      let categoryId =  this.$route.query.categoryId;
      this.$router.push({path: '/goods',   query: {categoryId: id}})
      if(categoryId != null && categoryId != id){
         location.reload()
      }

    },
    getCategoryIndexList() {
      this.$axios
          .get('/goods/category/index?pageSize=10&pageNum=1').then((res) => {
            this.categoryIndexList = res.data.data.rows;

            console.log(this.tableData)
          })
          .catch((err) => {
          });
    }
  }
}
;
</script>

<style>
.el-menu-item .is-active {
  color: unset !important;
}

.el-input__inner {
  background-color: transparent !important;
  border-color: black !important;
  color: black !important;
}



.el-submenu__icon-arrow >
.el-icon-arrow-down {
  color: white !important;
}

.development-timeline {
  position: relative;
  //padding: 20px 0;
  //margin: 40px 0;
}

.timeline {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.timeline-item {
  margin: 20px 0;
  text-align: center;
}

.timeline-item::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  height: 100%;
  border-left: 2px solid #ccc; /* 纵向线条 */
  transform: translateX(-50%);
}

.timeline-content {
  position: relative;
  background: #fff; /* 背景色 */
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.timeline-date {
  font-weight: bold;
  margin-bottom: 10px;
}

.timeline-image {
  max-width: 100%;
  height: auto;
  margin: 10px 0;
}

.timeline-description {
  color: #555;
}

.header-wrapper {
  position: fixed; /* 确保 header 固定在顶部 */
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* 设置 z-index 确保在最上方 */
  /*background-color: rgba(255, 255, 255, 0.9); !* 可选：设置背景色 *!*/
}

.main-content {
  margin-top: 64px; /* 确保内容不被 header 覆盖 */
}

.carousel-video::-webkit-media-controls-timeline {
  display: none;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.product-item {
  padding-left: 10px;
  flex: 0 1 calc(33.333% - 10px); /* 每行三张图片，间隔10px */
  margin-bottom: 20px; /* 每行的底部间隔 */
  text-align: center;
  overflow: hidden; /* 确保图片不会超出边界 */
  transition: transform 0.3s ease; /* 动画效果 */
}

.product-item img {
  width: 100%; /* 使图片充满容器 */
  height: auto; /* 保持比例 */
  display: block; /* 去掉底部的空隙 */
}

.product-item:hover {
  transform: scale(1.05); /* 悬停时放大 */
}

.product-item h3,
.product-item p {
  margin: 10px 0; /* 添加上下间距 */
}

.statistic {
  text-align: center;
  margin-top: 20px;
}

.company-culture {
  padding: 20px;
  background-color: #fff; /* 可根据需要调整背景颜色 */
}

.statistics-container {
  display: flex; /* 水平排列 */
  justify-content: space-around; /* 平均分布 */
  padding: 6rem;
}

.statistic-item {
  text-align: center; /* 中心对齐 */
}

.value {
  font-size: 3.2rem; /* 可根据需要调整字体大小 */
  font-weight: bold; /* 加粗数值 */
}

.label {
  font-size: 16px; /* 可根据需要调整字体大小 */
}

.company-background {
  padding: 20px;
}

.el-steps {
  margin: 20px 0;
}

.el-steps {
  margin: 20px 0;
}

/* 公司背景、文化、产品块 */
.company-info {
  margin-top: 50px;
}

.info-block {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.5s ease-in-out;
  //margin: 40px 0;
  text-align: center;
}

.info-block.in-view {
  opacity: 1;
  transform: translateY(0);
}

.info-block h2 {
  font-size: 30px;
  margin-bottom: 20px;
}

.info-block p {
  font-size: 18px;
  color: #555;
}

/* 基本样式 */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #333333;
  /*background-color: #F0F0F0;*/
  //background-color: rgb(250, 212, 162);
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 保证页面高度至少和视口高度相同 */
}

/* 重置样式 */
.el-main,
.el-card__body {
  padding: 0; /* 取消默认内边距 */
  border: none; /* 取消边框 */
}

/* 重置样式 */
.el-menu.el-menu--horizontal,
.el-submenu.is-active .el-submenu__title,
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none; /* 取消边框 */
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none; /* 取消边框 */
}

.el-submenu__title {
  background-color: transparent !important;
  //color: white !important;
}

.el-menu el-menu--popup {
  background-color: black !important; /* 设置透明背景 */
}

/* 使 el-menu-demo, el-menu--horizontal, el-menu 背景透明 */
.el-menu-demo,
.el-menu--horizontal,
.el-menu {
  //text-shadow: 0 0 10px rgba(0, 0, 0, 0.7) !important;
  background: transparent !important; /* 设置透明背景 */
  border: none !important; /* 去掉边框 */
}

/* 重置样式，防止active状态下的背景颜色覆盖透明效果 */
.el-menu--horizontal > .el-menu-item.is-active {
  background-color: black; /* 取消选中时的背景颜色 */
  border-bottom: none; /* 去掉底部边框 */
}

/* 菜单项的样式 */
.el-menu-item {
  background-color: transparent !important;
  border: none !important; /* 去掉边框 */
  //color: white !important; /* 菜单项文字颜色 */
}

.el-menu-item:hover {
  background-color: transparent !important;
}


/* 导航菜单样式 */
.el-menu-demo {
  //text-shadow: 0 0 10px rgba(0, 0, 0, 0.7) !important;
  background-color: rgba(51, 51, 51, 0.7); /* 半透明背景 */
}


.el-menu-item a {
  color: #fff;
  text-decoration: none;
}

.el-menu-item a.router-link-active {
  color: #409EFF;
}

.company-name {
  width: 200px;
  letter-spacing: .2em;
  margin-right: 20px; /* 菜单和公司名称之间的间距 */
  position: absolute;
  left: 50px;
}

.el-header {
  background-color: transparent; /* 使头部背景透明 */
  height: 60px;
  line-height: 60px;
  position: absolute; /* 绝对定位 */
  width: 100%; /* 宽度100% */
  z-index: 10; /* 提高层级使其在走马灯上方 */
  display: flex; /* 使用 Flexbox */
  justify-content: center; /* 水平居中 */
}

/* 页脚样式 */
.footer {
  background-color: #333;
  height: auto !important;
  padding: 0 !important;
}

.footer-container {
  //display: flex;
  color: #999;
  justify-content: center; /* 居中对齐 */
  max-width: 1200px;
  margin: 0 auto;
  gap: 50px; /* 各部分之间的间距 */
}

.footer-section {
  text-align: left; /* 每个部分的文本居中 */
}

.footer-section h3 {
  font-size: 14px;
  margin-bottom: 15px; /* 增加底部间距 */
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0; /* 清除外边距 */
}

.footer-section ul li {
  margin: 5px 0; /* 项目之间的间距 */
}

.footer-section a {
  color: #999;
  text-decoration: none;
}

.footer-section a:hover {
  text-decoration: underline;
}

/* 走马灯样式 */
.main-content {
  flex: 1; /* 让主要内容部分填充剩余空间 */
  overflow: hidden; /* 防止内容溢出 */
}

.carousel-item {
  position: relative;
  background-size: cover;
  background-position: center;
  height: 100vh; /* 确保整体高度为视口高度 */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.carousel-video {
  position: absolute; /* 绝对定位 */
  top: 0; /* 顶部对齐 */
  left: 0; /* 左侧对齐 */
  width: 100vw; /* 宽度为视口宽度 */
  height: 100vh; /* 高度为视口高度 */
  object-fit: cover; /* 使视频保持比例填充 */
}


.el-carousel .carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
  background-size: cover;
  background-position: center;
  height: 100%;
  letter-spacing: .2em;
}

/* 内容样式 */
.content {
  margin: 40px 0;
  text-align: center;
}

.service-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 20px auto;
}

.service {
  width: 250px;
  padding: 20px;
  text-align: center;
}

.service img {
  width: 100px;
  height: 100px;
  margin-bottom: 15px;
}

.service h3 {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
}

.service p {
  color: #555;
}

/* 额外的重置样式 */
html,
body {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

::-webkit-scrollbar {
  width: 0px !important;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: silver;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
}

/* 背景块 */

.background-block {
  //background-color: rgb(250, 212, 162);
  /*background-color: #F0F0F0;*/
  padding: 50px;
}

.background-block h2 {
  font-size: 36px;
  margin-bottom: 20px;
}

.background-block p {
  font-size: 18px;
  color: #555;
}

.background-block img {
  margin-top: 20px;
  max-width: 100%;
  height: auto;
}

.product-item img {
  max-width: 100%;
  height: auto;
}

.product-item h3 {
  margin-top: 15px;
  font-size: 20px;
}

.product-item p {
  margin-top: 10px;
  color: #666;
}

@media (max-width: 768px) {
  .product-item {
    flex: 0 1 calc(50% - 10px); /* Switch to 2 images per row on smaller screens */
  }
}

@media (max-width: 480px) {
  .product-item {
    flex: 0 1 100%; /* Switch to 1 image per row on very small screens */
  }
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.header-content img {
  height: 60px;
}

.el-menu-demo {
  line-height: 60px;
}

.company-name {
  cursor: pointer;
}

.main-content {
  position: relative;
}

.carousel-item {
  height: 100vh;
  background-size: cover;
  background-position: center;
  position: relative;
}

.carousel-video {
  width: 100%;
  height: 100%;
}

.video-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 1.5rem;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.7);
  //letter-spacing: .2em;
}

.play-pause-button {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
}

.company-info {
  background-color: #f5f5f5;
}

.footer-section h3 {
  margin-bottom: 10px;
}

.footer-section ul {
  list-style-type: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 5px;
}

.footer-section p {
  margin: 0;
}

</style>
